
import styles from './index.module.scss';
import RcmpKanbanCard from '../../atoms/KanbanCard';
import { Typography } from '@stardust-ds/react';
import PlusIconWithoutCircle from '../../../assets/icons/PlusIconWithoutCircle';
import intl from 'react-intl-universal';
import DragAndDropContext from '../../../contexts/DragAndDropContext';
import { useContext, useEffect, useMemo, useState, useRef, act } from 'react';
import { useParams } from "react-router"
import { pointerWithin, DndContext, DragOverlay, KeyboardSensor, PointerSensor, useDroppable, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, arrayMove, horizontalListSortingStrategy, sortableKeyboardCoordinates, verticalListSortingStrategy } from "@dnd-kit/sortable";
import RcmpLoading from '../../atoms/Loading';
import { createPortal } from 'react-dom';
import BoardContext from '../../../contexts/Board';
import RcmpCardEllipsis from '../../atoms/Ellipsis';
import { QRCodeCanvas } from "qrcode.react"
import { BlocksContext } from '../../../contexts/Blocks';

function Draggables(props) {
  const {
    aData,
    bLoading,
    nId,
    aFieldsName,
    cNotDataText,
    oCollumn,
    setOCurrentDrag,
    oCurrentDrag,
    fnHandleOpenEditActivityModal,
    bCanChange
  } = props

  return (
    <div className={styles.cardsContainer}>
      {!aData?.length ? (
        <p className={styles.notDataText}>{cNotDataText}</p>
      ) : (

        <>

          {aData?.map((oData, index) => {
            return (
              <div

                className={styles.cards}
                key={index}

              >
                <RcmpKanbanCard
                  oData={oData}
                  aFieldsName={aFieldsName}
                  nId={index}
                  setOCurrentDrag={setOCurrentDrag}
                  oCurrentDrag={oCurrentDrag}
                  onClick={fnHandleOpenEditActivityModal}
                  oCollumn={oCollumn}
                  bCanChange={bCanChange}
                />
              </div>
            )
          })}
        </>
      )}
      {!bLoading[nId] && <RcmpLoading bShow={true} size={50} />}
    </div>

  );
}

function DroppableKanbanArea(props) {
  const {
    header,
    index,
    bLoading,
    aData,
    oDragResult,
    oOnDragUpdate,
    nMaxRender,
    nRenderedItens,
    nTotalItens,
    cBottomText,
    cNotDataText,
    nId,
    setOCurrentDrag,
    oCurrentDrag,
    fnHandleOpenActivityModal,
    fnHandleOpenEditActivityModal,
    aEllipsisOption,
    fnSetData,
    bCanChange,
    fnLoadMoreActivities,
  } = props
  const aItensId = useMemo(() => aData[index]?.aData?.map((item) => item.id), [aData])
  const { setNodeRef } = useDroppable({
    id: `${header.id}-droppable`,
    data: {
      type: "Collumn"
    }
  })

  const fnHandleLoadMoreActivities = () => {
    if (!header?.can_load_more) return
    fnLoadMoreActivities(header.id, header)
  }

  const aBlockHiddenFields = header?.kanban_hidden_fields || []
  const aVisibleFields =
    aBlockHiddenFields?.length > 0
      ? header?.fieldsName
          ?.filter(
            (f) => !aBlockHiddenFields.find((h) => h?.ophf_ombf_nid === f?.ombf_nid),
          )
          ?.map((f) => f?.field) || []
      : header?.fieldsName?.map((f) => f?.field) || []
  
  const bHasActivity = aData[index]?.aData?.length > 0

  return (
    <SortableContext
      items={aItensId ?? []}
      strategy={verticalListSortingStrategy}
      id={`${header.id}-droppable`}
    >
      <div>
        <div className={styles.column}>
          <div className={styles.columnName}>
            <p type="h2" color={"#FFFFFF"}>
              {header.name}
            </p>
            {bCanChange && (
              <div style={{ position: "relative" }}>
                <RcmpCardEllipsis
                  className={styles.ellipsisIcon}
                  aOptions={aEllipsisOption}
                  fnSetData={fnSetData}
                  size={"240px"}
                  oDataItem={header}
                />
              </div>
            )}
          </div>
          {bLoading[header.id] && aData[index].aData?.length ? (
            <div className={styles.topText}>
              <p className={styles.displaying}>
                {intl.get("BlocksPage.displaying", {
                  from: aData[index].aData.length,
                  total: aData[index].total,
                })}
              </p>
            </div>
          ) : (
            <></>
          )}

          <div ref={setNodeRef} className={`${styles.listContainer} ${!bHasActivity ? styles.emptyList : ""}`}>
            <div>
              <Draggables
                aData={aData[index]?.aData}
                bLoading={bLoading}
                nId={header.id}
                oDragResult={oDragResult}
                oOnDragUpdate={oOnDragUpdate}
                aFieldsName={aVisibleFields}
                cNotDataText={cNotDataText}
                oCollumn={header}
                setOCurrentDrag={setOCurrentDrag}
                oCurrentDrag={oCurrentDrag}
                fnHandleOpenEditActivityModal={fnHandleOpenEditActivityModal}
                bCanChange={bCanChange}
              />
            </div>

            <div className={styles.footer}>
              {bLoading[header.id] && aData[index].aData?.length ? (
                <div className={styles.bottomText}>
                  <p className={styles.displaying}>
                    {intl.get("BlocksPage.displaying", {
                      from: aData[index].aData.length,
                      total: aData[index].total,
                    })}
                  </p>
                </div>
              ) : (
                <></>
              )}
              {aData?.[index]?.can_load_more && (
                <div
                  className={styles.seeMoreButton}
                  onClick={fnHandleLoadMoreActivities}
                >
                  <p>{intl.get("BlocksPage.see_more")}</p>
                </div>
              )}
              {bLoading[header.id] && bCanChange && (
                <div
                  className={styles.bottomArea}
                  onClick={() => fnHandleOpenActivityModal(header)}
                >
                  <PlusIconWithoutCircle fill="#3B454F" width={15} height={15} />
                  <Typography type="l3" color={"#3B454F"}>
                    {cBottomText}
                  </Typography>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </SortableContext>
  )
}
export default function RcmpKanban(props) {
  const {
    aData,
    cBottomText,
    nTotalItens,
    nRenderedItens,
    cNotDataText,
    nMaxRender,
    bLoading,
    aHeaders,
    fnHandleOpenActivityModal,
    fnReorderActivitiesSubmit,
    oMoveActivity,
    fnSetABlocksToList,
    fnReorderActivitiesReq,
    fnHandleOpenEditActivityModal,
    aEllipsisOption,
    fnSetData,
    bCanChange,
    fnLoadMoreActivities,
  } = props
  const [activeId, setActiveId] = useState(null)
  const { oUpdateBoardModelRes, } = useContext(BoardContext)
  const { oDragResult, oOnDragUpdate } = useContext(DragAndDropContext)
  const [aDataRender, setADataRender] = useState(aData ? [...aData] : []);
  const [oCurrentDrag, setOCurrentDrag] = useState(null)
  const [bIsDroppedByOver, setBIsDroppedByOver] = useState(false)
  const { setNodeRef } = useDroppable({
    id: `droppableContaienr`,
  })
  const qrCodeRef = useRef([])
  const baseUrl = process.env.REACT_APP_BASE_URL

  const { boardId: nBoardId, panelId: nPanelId } = useParams()

    const {
      aBlocks,
      fnSetABlocks,
    } = useContext(BlocksContext)

    useEffect(() => {
      if (!aData?.length) return
      setADataRender(aData)
    }, [aData])

  useEffect(() => {
    if (oMoveActivity.loading || oMoveActivity.data) return
    setADataRender(aData)
  }, [aData, oUpdateBoardModelRes])


  const aCollumnsId = useMemo(() => aData.map((item) => item.id), [aData])
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates
    })
  )

  function fnHandleDragStart(event) {
    setActiveId(event.active.id);
  }

  async function fnSubmitNewPositionBetweenBlocks(nCardId, aData, bIsSameCollumn) {
    const aCollumnIndex = aData.findIndex(data => {
      return data.aData.find(oCard => oCard.id === nCardId)
    })
    const oPayload = aData[aCollumnIndex].aData.map((data, i) => {
      return {
        opat_nid: data.opat_nid,
        position: i
      }
    })

    if (bIsSameCollumn) {
      await fnReorderActivitiesReq(aData[aCollumnIndex].id, oPayload)
    } else {
      await fnReorderActivitiesSubmit(nCardId, aData[aCollumnIndex].id, true)
    }
  }

  function fnHandleDragEnd(event) {
    const { active, over } = event;
    const nActiveId = active.id;
    const nOverId = over?.id;

    if (!over) return;
    
    const oOrignalBlock = aBlocks?.find(
      (block) =>
        block.activities?.find((item) => item?.opat_nid === nActiveId) ||
        block.activities_pending?.find((item) => item?.opat_nid === nActiveId),
    )
    if (bIsDroppedByOver) {
      setADataRender((prev) => {
        const nOriginCollumn = prev.reduce((acc, column, columnIndex) => {
          const item = column.aData.filter(item => item.id === nActiveId);
          if (item.length) {
            acc = { columnIndex, itemIndex: item[0] };
          }
          return acc;
        }, null);

        if (!nOriginCollumn) {
          console.error("Origin column not found");
          return prev;
        }

        //collumn destination
        const nCollumnIndex = nOriginCollumn.columnIndex;
        if (nCollumnIndex === -1 || nCollumnIndex === -1) {
          console.error("Invalid column index");
          return prev;
        }

        const nItemAcitveIndex = nOriginCollumn.itemIndex;

        if (nItemAcitveIndex === -1) {
          console.error("Invalid item index");
          return prev;
        }

        // Check if item index is valid
        if (nItemAcitveIndex === -1) {
          console.error("Invalid item index");
          return prev;
        }


        // Create a copy of the state to avoid direct mutation
        const newState = prev.map((column, index) => {
          let  total = column.total
          if (column?.opbl_nid === oOrignalBlock?.opbl_nid) {
            total = column.total - 1
          }

          if (index === nCollumnIndex) {
            total = column.total + 1
          }

          return {
            ...column,
            aData: column.aData.map((item, i) => {
              if (item.id === nActiveId) {
                return { ...item, originId: index, position: i }
              }
              return { ...item, position: i }
            }),
            activities_pending: column.aData
              ?.filter((a) => a?.status?.toLowerCase() === "pending")
              ?.map((item, i) => {
                if (item.id === nActiveId) {
                  return { ...item, originId: index, position: i }
                }
                return { ...item, position: i }
              }),
            activities: column.aData
              ?.filter((a) => a?.status?.toLowerCase() === "done")
              ?.map((item, i) => {
                if (item.id === nActiveId) {
                  return { ...item, originId: index, position: i }
                }
                return { ...item, position: i }
              }),
            total: total,
          }
        });


        // Return the updated state
        fnSetABlocks(newState)
        fnSubmitNewPositionBetweenBlocks(nActiveId, newState, false)
        return newState;
      });

    }
    // setBIsDroppedByOver(false)
    //     setOCurrentDrag(null)
    if (!over) return


    if (nActiveId === nOverId) return

    //update positions in the array

    setADataRender((prev) => {
      const oCollumnId = event.active.data.current.sortable.containerId.split("-")[0]
      const nCollumnIndex = aDataRender.findIndex(column => column.id === Number(oCollumnId))
      const nItemAcitveIndex = aDataRender[nCollumnIndex].aData.findIndex(item => item.id === active.id)
      const nOverCollumIndex = aDataRender[nCollumnIndex].aData.findIndex(column => column.id === Number(nOverId))


      const aNewPosition = arrayMove(aDataRender[nCollumnIndex].aData, nItemAcitveIndex, nOverCollumIndex);

      const newState = [...prev];
      newState[nCollumnIndex] = {
        ...newState[nCollumnIndex],
        aData: aNewPosition,
        activities_pending: aNewPosition?.filter(a => a?.status?.toLowerCase() === "pending"),
        activities: aNewPosition?.filter(a => a?.status?.toLowerCase() === "done"),
      };
      if (!bIsDroppedByOver) {
        fnSubmitNewPositionBetweenBlocks(nActiveId, newState, true)
      }

      fnSetABlocks(newState)
      return newState;
    })
    setBIsDroppedByOver(false)
    setOCurrentDrag(null)
    setOCurrentDrag(null)
    setActiveId(null);
  }

  function fnHandleDragMove(event) {
    setActiveId(event.active.id);
    const oCollumnId = event.active.data.current.sortable.containerId.split("-")[0]
    const oItem = aData.find(column => column.id === Number(oCollumnId))
    const aFields = aHeaders.find(header => header.id === Number(oCollumnId)).fieldsName

    if (oCurrentDrag === null) {
      setOCurrentDrag({
        oData: oItem.aData[event.active.data.current.sortable.index],
        aFieldsName: aFields,
        nId: event.active.id
      });
    }

  }

  function fnHandleDragOver(event) {
    const { active, over } = event

    if (!over) return

    const nActiveId = active.id
    const nOverId = over.id
    if (nActiveId === nOverId) return
    const oCurrentCollumnId = event?.over?.data?.current?.sortable?.containerId

    if (oCurrentCollumnId === active.data.current.sortable.containerId || active.data.current.sortable?.containerId === over.id) return

    setBIsDroppedByOver(true)
    const bIsActiveCollumn = over.data.current.type === "Collumn"
    const bIsOverIsAItem = over.data?.current?.type === "Card"
    const bIsOverIsADraggingItem = over.data?.current?.type === "draggingCard"
    // Drop a card in another card
    if (bIsOverIsAItem) {
      setADataRender((prev) => {
          const nOriginCollumn = prev.reduce((acc, column, columnIndex) => {
          const itemIndex = column.aData.findIndex(item => item.id === activeId);
          if (itemIndex !== -1) {
            acc = { columnIndex, itemIndex };
          }
          return acc;
        }, null);

        const oDestinationCollunId = over.data.current.sortable.containerId.includes("droppable") ? Number(over.data.current.sortable.containerId.split("-")[0]) : Number(over.data.current.sortable.containerId);
        // Find the index of the current column in the aDataRender array
        const nCollumnIndex = nOriginCollumn.columnIndex
        // Find the index of the destination column in the aDataRender array
        const nDestinationCollumnIndex = prev.findIndex(column => column.id === Number(oDestinationCollunId) || column.id === Number(nOverId));
        // Check if indices are valid
        if (nCollumnIndex === -1 || nDestinationCollumnIndex === -1) {
          console.error("Invalid column index");
          return prev;
        }

        // Find the index of the active item in the current column's data array
        const nItemAcitveIndex = prev[nCollumnIndex].aData.findIndex(item => item.id === nActiveId);

        // Check if item index is valid
        if (nItemAcitveIndex === -1) {
          console.error("Invalid item index");
          return prev;
        }
        // Create a copy of the state to avoid direct mutation

        const newState = aDataRender.map((column, index) => ({
          ...column,
          aData: column.aData.map((item, i) => {
            if (item.id === activeId) {
              return { ...item, originId: index };
            }
            return item
          }),
        }));
        const [movedItem] = newState[nCollumnIndex].aData.splice(nItemAcitveIndex, 1);

        newState[nDestinationCollumnIndex].aData.push(movedItem);

        // Return the updated state
        return newState;
      });
    }

    //Drop a card in another collumn
    if (bIsActiveCollumn || bIsOverIsADraggingItem) {
      const oCurrentCollumnId = event.active.data.current.sortable.containerId.split("-")[0];

      setADataRender((prev) => {
        // Get the destination column ID from the over ID
        const oDestinationCollunId = nOverId.split("-")[0];
        // Find the index of the current column in the aDataRender array
        const nCollumnIndex = prev.findIndex(column => column.id === Number(oCurrentCollumnId));
        // Find the index of the destination column in the aDataRender array
        const nDestinationCollumnIndex = prev.findIndex(column => column.id === Number(oDestinationCollunId));
        // Check if indices are valid
        if (nCollumnIndex === -1 || nDestinationCollumnIndex === -1) {
          console.error("Invalid column index");
          return prev;
        }

        // Find the index of the active item in the current column's data array
        const nItemAcitveIndex = prev[nCollumnIndex].aData.findIndex(item => item.id === nActiveId);

        // Check if item index is valid
        if (nItemAcitveIndex === -1) {
          console.error("Invalid item index");
          return prev;
        }

        // Create a copy of the state to avoid direct mutation
        const newState = aDataRender.map((column, index) => ({
          ...column,
          aData: column.aData.map((item, i) => {
            if (item.id === activeId) {
              return { ...item, originId: index, position: i };
            }
            return { ...item, position: i }
          }),
        }));
        const [movedItem] = newState[nCollumnIndex].aData.splice(nItemAcitveIndex, 1);
        newState[nDestinationCollumnIndex].aData.push(movedItem);

        // Return the updated state
        return newState;
      });
    }


  }

  function setRef(index, el) {
    qrCodeRef.current[index] = el
  }
  return (
    <DndContext
      sensors={sensors}
      collisionDetection={pointerWithin}
      // announcements={defaultAnnouncements}
      onDragStart={fnHandleDragStart}
      onDragMove={fnHandleDragMove}
      onDragEnd={fnHandleDragEnd}
      onDragOver={fnHandleDragOver}
    >
      <div className={styles.container} ref={setNodeRef}>
        <SortableContext
          items={aCollumnsId}
          strategy={horizontalListSortingStrategy}
          id="DroppableContainer"
        >
          <div className={styles.columnContainer}>
            {createPortal(
              <DragOverlay>
                {activeId && oCurrentDrag && (
                  <div className={styles.draggingCard}>
                    <RcmpKanbanCard
                      oData={oCurrentDrag.oData}
                      aFieldsName={oCurrentDrag.aFieldsName}
                      nId={oCurrentDrag.nId}
                      setOCurrentDrag={() => {}}
                      oCurrentDrag={oCurrentDrag}
                      bIsCardDragging={true}
                    />
                  </div>
                )}
              </DragOverlay>,
              document.body,
            )}

            {aHeaders.map((header, index) => {
              return (
                <>
                  <DroppableKanbanArea
                    key={index}
                    header={header}
                    index={index}
                    bLoading={bLoading}
                    aData={aDataRender}
                    oDragResult={oDragResult}
                    oOnDragUpdate={oOnDragUpdate}
                    nMaxRender={nMaxRender}
                    nRenderedItens={nRenderedItens}
                    nTotalItens={nTotalItens}
                    cBottomText={cBottomText}
                    cNotDataText={cNotDataText}
                    setOCurrentDrag={setOCurrentDrag}
                    oCurrentDrag={oCurrentDrag}
                    fnHandleOpenActivityModal={fnHandleOpenActivityModal}
                    fnHandleOpenEditActivityModal={fnHandleOpenEditActivityModal}
                    aEllipsisOption={aEllipsisOption}
                    fnSetData={fnSetData}
                    bCanChange={bCanChange}
                    fnLoadMoreActivities={fnLoadMoreActivities}
                  />
                  <QRCodeCanvas
                    id={`qrCodeBlock-${header.opbl_nid}`}
                    value={`${baseUrl}dashboard/${nPanelId}/boards/${nBoardId}/${header?.opbl_nid}`}
                    renderAs={"canvas"}
                    size={1024}
                    level={"L"}
                    includeMargin={false}
                    ref={setRef(index, header)}
                    style={{ display: "none" }}
                  />
                </>
              )
            })}
          </div>
        </SortableContext>
      </div>
    </DndContext>
  )
}